import React, { useEffect } from "react";
import { useDispatch } from "react-redux";

//import Scss
import "./assets/scss/themes.scss";
import "react-toastify/dist/ReactToastify.css";

//import Route
import Route from "./Routes";

// Import auth helpers
import { initializeAuth, getLoggedinUser } from "./helpers/api_helper";
import { loginSuccess } from "./slices/auth/login/reducer";

function App() {
  const dispatch = useDispatch();

  useEffect(() => {
    // Initialize authentication state from localStorage on app start
    const token = initializeAuth();
    const user = getLoggedinUser();

    if (token && user) {
      // Restore Redux auth state if user data exists
      dispatch(loginSuccess(user));
    }
  }, [dispatch]);

  return (
    <React.Fragment>
      <Route />
    </React.Fragment>
  );
}

export default App;
